import { Link } from "react-router-dom";
import type { ReactNode } from "react";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
  icon?: string;
  children?: ReactNode;
}

export default function SectionHeading({
  title,
  subtitle,
  moreTo,
  moreLabel = "查看更多",
  icon,
  children,
}: SectionHeadingProps) {
  return (
    <div className="mb-5 flex items-end justify-between gap-4">
      <div>
        <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          {icon && <i className={`${icon} text-accent-500`}></i>}
          {title}
        </h2>
        {subtitle && <p className="mt-1 text-sm text-foreground-400">{subtitle}</p>}
      </div>
      {children}
      {moreTo && (
        <Link
          to={moreTo}
          className="hidden shrink-0 items-center gap-1 text-sm text-foreground-400 transition-colors hover:text-accent-500 cursor-pointer sm:flex"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line text-lg"></i>
        </Link>
      )}
    </div>
  );
}